import { organizeData, savedata } from "../functions"

const handleDate = (dateParam) => {
    // code to change format
}

const handleClick = (props) => {
  console.log('CLICK...')
  const { setter, name, values, url, headers, api, IdEmp, setTryToSave, setAbleToSave, ableToSave, ip, setShowGrid, setLoading } = props
  console.log(headers)
  console.log(url)
  
  const opciones = {
    "cancelarAlumno" : () => {
      setter(false)
    },
    "cancelarTutor" : () => {
      setter(false)
    },
    "guardarAlumno" : () => {
      //llamar a otra funcion para guardar el alumno en el estado general
      setter(false)
    },
    "guardarTutor" : () => {
      //llamar a otra funcion para guardar el tutor en el estado general
      setter(false)
    },
    "guardarDatos" : async () => {
      setTryToSave(()=> true)
      const valuesToSend = await organizeData({values: values, IdEmp: IdEmp,setAbleToSave:setAbleToSave, ip:ip})
      console.log(valuesToSend)

      if(!Object.keys(valuesToSend).some(e => !valuesToSend[e])){
        setAbleToSave(true)
        const response = await savedata({valores: valuesToSend, url:url, headers: headers, api: api, setter: setter, ip:ip, setLoading:setLoading})
        console.log(response)
        // saveData(organizeData(values))
        if(response.message){
          setLoading(false)
          setter({
            ok: false,
            show: true,
            msg: "No se guardaron los datos"
          })
        }else{
          setLoading(false)
          setter({
            ok: true,
            show: true,
            msg: response.msg.Mensaje || "Datos guardados con éxito"
          })
          setShowGrid(true)
        }
      }else{
        setter({
          ok: false,
          show: true,
          msg: "Ingrese todos los datos"
        })
      }
      /*
        setter({
          ok: response.msg.Error === "0" ? true: false,
          show: true,
          msg: response.msg.Error === "0" ? "Datos guardados correctamente" : response.msg.Mensaje
        })
        */
        // limpiar Form
        // setterValues({})
      
    }
  }
  opciones[name]()
}

const handleEditar = (props) => {
  const { setter, name } = props

  const opciones = {
    "editarAlumno": () => {
      setter(true)
    },
    "editarTutor": () => {
      setter(true)
    }
  }
  opciones[name]()
}

export {
    handleDate,
    handleClick,
    handleEditar,
}